import MasonryCard from './MasonryCard'
export default MasonryCard
